import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import * as types from 'misc/types';

import status_check from './status_check';
import sessions from './sessions';
import agreement from './agreement';
import customer from './customer';
import texts from './texts';
import medias from './medias';
import tags from './tags';
import government_status from './government_status';
import government_list from './government_list';
import company from './company';
import envelopes_inbox from './envelopes_inbox';
import envelopes_archives from './envelopes_archives';
import envelope from './envelope';
import envelope_contents from './envelope_contents';
import envelope_content_inline from './envelope_content_inline';
import envelope_content_document from './envelope_content_document';
import search_results from './search_results';
import popup from './popup';
import verifications from './verifications';

const reducers = {
    routing: routerReducer,
    form: formReducer,
    status_check: status_check,
    sessions: sessions,
    agreement: agreement,
    customer: customer,
    texts: texts,
    medias: medias,
    tags: tags,
    government_status: government_status,
    government_list: government_list,
    company: company,
    envelopes_inbox: envelopes_inbox,
    envelopes_archives: envelopes_archives,
    envelope: envelope,
    envelope_contents: envelope_contents,
    envelope_content_inline: envelope_content_inline,
    envelope_content_document: envelope_content_document,
    search_results: search_results,
    popup: popup,
    verifications: verifications
};

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
    if (action.type === types.SAGA_LOGOUT.SUCCESS) {
        state = undefined;
        sessionStorage.clear();
    }

    return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js